import { OfficeFluidLogger } from '@fluidx/telemetry';
import { AppHostContext } from './hostContext/AppHostContext';
import { OUTLOOK_APP_NAME } from '../constants';

export function getAppLogger(hostContext: AppHostContext): OfficeFluidLogger {
    const officeFluidLogger = new OfficeFluidLogger({
        namespace: OUTLOOK_APP_NAME,
        hostContextProps: hostContext,
    });
    return officeFluidLogger;
}
